<template>
  <div class="monitor-page" id="videoMaincontent1">
    <div class="nav flex_bc" v-if="topTag">
      <ul class="tags flex_bc">
        <li
          v-for="(item, index) in list"
          :key="index"
          @click="handleTag(item.num, index)"
          :class="{ active: tagCheck == index }"
        >
          {{ item.name }}
        </li>
      </ul>
      <!-- <div class="page-con flex_bc">
        <div>上一页</div>
        <span>
          <i>1</i>
          / 4
        </span>
        <div>下一页</div>
      </div> -->
    </div>
    <!-- 视频中心 -->
    <div
      id="playWnd"
      ref="affair"
      :style="{ width: swfWidth + 'px', height: swfHeight + 'px' }"
    ></div>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    name: 'monitor-page',
    props: {
      M_list: {
        type: Array,
        default: () => {
          return []
        },
      },
      topTag: {
        type: Boolean,
        default: true,
      },
      page: {
        type: Number,
        default: 4,
      },
    },
    data() {
      return {
        list: [
          { name: '单宫格', num: '1x1' },
          { name: '四宫格', num: '2x2' },
          { name: '九宫格', num: '3x3' },
          { name: '十六宫格', num: '4x4' },
        ],
        tagCheck: 1,
        // 监控
        swfHeight: '',
        swfWidth: '',
        oWebControl: null,
        playMode: 0, //初始播放模式：0-预览，1-回放
        layout: '2x2',
        pubKey: '',
        HKcode: '',
        initNum: 0,
        timer: null,
      }
    },
    // watch: {
    //   M_list: {
    //     handler: function (list) {
    //       console.log(list, 'obj改变了')
    //     },
    //     // 开启深度监听：只要obj中的任何一个属性发生改变，都会触发相应的代码
    //     deep: true,
    //   },
    // },
    mounted() {
      this.resizeBox()
      this.layout = this.page === 0 ? '1x1' : '2x2'
      this.setPlugin(this.page)
    },
    methods: {
      checkliItem(code) {
        this.HKcode = code
        // 海康设备
        if (!this.oWebControl) {
          this.setPlugin()
        } else {
          this.startPreview()
        }
      },
      handleTag(item, index) {
        this.tagCheck = index
        this.layout = item
        // 海康设备
        if (!this.oWebControl) {
          this.setPlugin()
        } else {
          this.setLayout(item)
        }
      },
      // 视频
      setPlugin(wndId) {
        let that = this
        this.swfHeight =
          document.getElementById('videoMaincontent1').offsetHeight - 60
        this.swfWidth = document.getElementById('videoMaincontent1').offsetWidth
        this.initPlugin(() => {
          that.startPreview(wndId)
        })
      },
      // 视频“预览”功能
      startPreview(w_num) {
        let that = this
        let streamMode = 0
        let transMode = 1
        let gpuMode = 0
        let isDirectEzviz = +0
        let wndId = -1 // 默认为空闲窗口预览
        if (w_num) {
          let dataArr = []
          let arr = that.M_list.splice(0, w_num)
          let codeStr = arr.map((item) => {
            return item.name
          })
          codeStr.forEach((i, index) => {
            dataArr.push({
              cameraIndexCode: i,
              streamMode: streamMode,
              transMode: transMode,
              gpuMode: gpuMode,
              wndId: index + 1,
              ezvizDirect: isDirectEzviz,
            })
          })
          this.oWebControl
            .JS_RequestInterface({
              funcName: 'startMultiPreviewByCameraIndexCode',
              argument: JSON.stringify({ list: dataArr }),
            })
            .then(function (oData) {
              that.showCBInfo(JSON.stringify(oData ? oData.responseMsg : ''))
            })
        } else {
          let cameraIndexCode = this.HKcode || this.M_list[0].name
          cameraIndexCode = cameraIndexCode.replace(/(\s*$)/g, '')
          this.oWebControl
            .JS_RequestInterface({
              funcName: 'startPreview',
              argument: JSON.stringify({
                cameraIndexCode: cameraIndexCode,
                streamMode: streamMode,
                transMode: transMode,
                gpuMode: gpuMode,
                wndId: wndId,
              }),
            })
            .then(function (oData) {
              that.showCBInfo(JSON.stringify(oData ? oData.responseMsg : ''))
            })
        }
      },
      // 设置当前布局
      setLayout(item) {
        // var cameraIndexCode = this.HKcode //获取输入的监控点编号值，必填
        // var recordLocation = 1 //录像存储位置：0-中心存储，1-设备存储
        // var transMode = 1 //传输协议：0-UDP，1-TCP
        // var gpuMode = 0 //是否启用GPU硬解，0-不启用，1-启用
        // var wndId = -1 //播放窗口序号（在2x2以上布局下可指定播放窗口）
        this.oWebControl.JS_RequestInterface({
          funcName: 'setLayout',
          argument: JSON.stringify({
            layout: item,
            // cameraIndexCode: cameraIndexCode, //监控点编号
            // // startTimeStamp: Math.floor(form.startTime / 1000).toString(), //录像查询开始时间戳，单位：秒
            // // endTimeStamp: Math.floor(form.endTime / 1000).toString(), //录像结束开始时间戳，单位：秒
            // playMode: 1, //播放模式（决定显示预览还是回放界面）
            // recordLocation: recordLocation, //录像存储类型：0-中心存储，1-设备存储
            // transMode: transMode, //传输协议：0-UDP，1-TCP
            // gpuMode: gpuMode, //是否启用GPU硬解，0-不启用，1-启用
            // wndId: wndId, //可指定播放窗口
          }),
        })
      },
      initPlugin(callback) {
        let self = this
        let WebControl = window.WebControl
        this.oWebControl = new WebControl({
          szPluginContainer: 'playWnd', // 指定容器id
          iServicePortStart: 15900, // 指定起止端口号，建议使用该值
          iServicePortEnd: 15909,
          szClassId: '23BF3B0A-2C56-4D97-9C03-0CB103AA8F11', // 用于IE10使用ActiveX的clsid
          // 创建WebControl实例成功
          cbConnectSuccess: () => {
            self.initNum = 0
            self.oWebControl
              .JS_StartService('window', {
                // WebControl实例创建成功后需要启动服务
                dllPath: './VideoPluginConnect.dll', // 值"./VideoPluginConnect.dll"写死
              })
              .then(
                function () {
                  // 启动插件服务成功
                  self.oWebControl.JS_SetWindowControlCallback({
                    // 设置消息回调
                    cbIntegrationCallBack: self.cbIntegrationCallBack,
                  })
                  self.oWebControl
                    .JS_CreateWnd('playWnd', self.swfWidth, self.swfHeight)
                    .then(function () {
                      // JS_CreateWnd创建视频播放窗口，宽高可设定
                      self.init(callback) // 创建播放实例成功后初始化
                    })
                },
                function () {
                  // 启动插件服务失败
                }
              )
          },
          // 创建WebControl实例失败
          cbConnectError: () => {
            clearInterval(self.timer)
            let id = document.getElementById('playWnd')
            id.innerHTML =
              '<p style="line-height: 3;color: #fff">"插件未启动，正在尝试启动，请稍候..."</p>'
            // $("#playWnd").html("插件未启动，正在尝试启动，请稍候...");
            self.initNum++
            if (self.initNum < 2) {
              setTimeout(function () {
                self.initPlugin(null)
              }, 3000)
              WebControl.JS_WakeUp('VideoWebPlugin:// ') // 程序未启动时执行error函数，采用wakeup来启动程序
            } else {
              id.innerHTML =
                "<p style='width: 80%; margin: 0 auto; padding-top: 30px;'>插件启动失败，请检查插件是否安装！" +
                "<a target='_blank' style='color: blue' href='https://116.178.28.135:65231/bic/fileService/v1/products/Infovision%20iBuilding-Site_V1.4.0_20210318.20210311200408/download/item_435225/VideoWebPlugin.exe'>" +
                '下载安装</a></p>'
              // $("#playWnd").html("<p style='padding-top: 30px;'>插件启动失败，请检查插件是否安装！<a target='_blank' href='https://116.178.28.135:65231/bic/fileService/v1/products/Infovision%20iBuilding-Site_V1.4.0_20210318.20210311200408/download/item_435225/VideoWebPlugin.exe'>下载安装</a></p>");
            }
          },
          // 异常断开：bNormalClose = false
          cbConnectClose: () => {
            // JS_Disconnect正常断开：bNormalClose = true
            console.log('cbConnectClose异常断开')
            self.oWebControl = null
          },
        })
      },
      // 推送消息
      cbIntegrationCallBack(oData) {
        this.showCBInfo(JSON.stringify(oData.responseMsg))
      },
      // 初始化
      init(callback) {
        let that = this
        this.getPubKey(() => {
          var appkey = '24429540' //综合安防管理平台提供的appkey，必填
          var secret = that.setEncrypt('1Fn8kap2Jyn0hzYuFRhu') //综合安防管理平台提供的secret，必填
          var ip = '116.178.28.135' //综合安防管理平台IP地址，必填                               //初始播放模式：0-预览，1-回放
          var port = 65231 //综合安防管理平台端口，若启用HTTPS协议，默认443
          var snapDir = 'D:\\SnapDir' //抓图存储路径
          var videoDir = 'D:\\VideoDir' //紧急录像或录像剪辑存储路径
          // var layout = '3x3' //playMode指定模式的布局
          var enableHTTPS = 1 //是否启用HTTPS协议与综合安防管理平台交互，这里总是填1
          var encryptedFields = 'secret' //加密字段，默认加密领域为secret
          var showToolbar = 0 //是否显示工具栏，0-不显示，非0-显示
          var showSmart = 0 //是否显示智能信息（如配置移动侦测后画面上的线框），0-不显示，非0-显示
          var buttonIDs =
            '0,16,256,257,258,259,260,512,513,514,515,516,517,768,769'
          this.oWebControl
            .JS_RequestInterface({
              funcName: 'init',
              argument: JSON.stringify({
                appkey: appkey, //API网关提供的appkey
                secret: secret, //API网关提供的secret
                ip: ip, //API网关IP地址
                playMode: that.playMode, // 预览
                port: port, //端口
                snapDir: snapDir, //抓图存储路径
                videoDir: videoDir, //紧急录像或录像剪辑存储路径
                layout: that.layout, //布局
                enableHTTPS: enableHTTPS, //是否启用HTTPS协议
                encryptedFields: encryptedFields, //加密字段
                showToolbar: showToolbar, //是否显示工具栏
                showSmart: showSmart, //是否显示智能信息
                buttonIDs: buttonIDs, //自定义工具条按钮
              }),
            })
            .then(function (oData) {
              callback()
              that.showCBInfo(JSON.stringify(oData ? oData.responseMsg : ''))
              that.oWebControl.JS_Resize(that.swfWidth, that.swfHeight) // 初始化后resize一次，规避firefox下首次显示窗口后插件窗口未与DIV窗口重合问题
            })
        })
      },
      // 提示 json 数据
      showCBInfo(szInfo, type) {
        console.log(szInfo, type)
      },
      // 获取公钥
      getPubKey(callback) {
        let that = this
        this.oWebControl
          .JS_RequestInterface({
            funcName: 'getRSAPubKey',
            argument: JSON.stringify({
              keyLength: 1024,
            }),
          })
          .then((oData) => {
            if (oData.responseMsg.data) {
              that.pubKey = oData.responseMsg.data
              callback()
            }
          })
      },
      // RSA加密
      setEncrypt(value) {
        let JSEncrypt = window.JSEncrypt
        let encrypt = new JSEncrypt()
        encrypt.setPublicKey(this.pubKey)
        return encrypt.encrypt(value)
      },
      // 设置窗口裁剪，当因滚动条滚动导致窗口需要被遮住的情况下需要JS_CuttingPartWindow部分窗口
      setWndCover() {
        let iWidth = $(window).width()
        let iHeight = $(window).height()
        let oDivRect = $('#playWnd').get(0).getBoundingClientRect()
        let iCoverLeft = oDivRect.left < 0 ? Math.abs(oDivRect.left) : 0
        let iCoverTop = oDivRect.top < 0 ? Math.abs(oDivRect.top) : 0
        let iCoverRight =
          oDivRect.right - iWidth > 0 ? Math.round(oDivRect.right - iWidth) : 0
        let iCoverBottom =
          oDivRect.bottom - iHeight > 0
            ? Math.round(oDivRect.bottom - iHeight)
            : 0
        iCoverLeft = iCoverLeft > this.swfWidth ? this.swfWidth : iCoverLeft
        iCoverTop = iCoverTop > this.swfHeight ? this.swfHeight : iCoverTop
        iCoverRight = iCoverRight > this.swfWidth ? this.swfWidth : iCoverRight
        iCoverBottom =
          iCoverBottom > this.swfHeight ? this.swfHeight : iCoverBottom
        this.oWebControl.JS_RepairPartWindow(
          0,
          0,
          this.swfWidth + 1,
          this.swfHeight
        ) // 多1个像素点防止还原后边界缺失一个像素条
        if (iCoverLeft != 0) {
          this.oWebControl.JS_CuttingPartWindow(
            0,
            0,
            iCoverLeft,
            this.swfHeight
          )
        }
        if (iCoverTop != 0) {
          this.oWebControl.JS_CuttingPartWindow(
            0,
            0,
            this.swfWidth + 1,
            iCoverTop
          ) // 多剪掉一个像素条，防止出现剪掉一部分窗口后出现一个像素条
        }
        if (iCoverRight != 0) {
          this.oWebControl.JS_CuttingPartWindow(
            this.swfWidth - iCoverRight,
            0,
            iCoverRight,
            this.swfHeight
          )
        }
        if (iCoverBottom != 0) {
          this.oWebControl.JS_CuttingPartWindow(
            0,
            this.swfHeight - iCoverBottom,
            this.swfWidth,
            iCoverBottom
          )
        }
      },
      getViewportSize() {
        return {
          width:
            window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth,
          height:
            window.innerHeight ||
            document.documentElement.clientHeight ||
            document.body.clientHeight,
        }
      },
      resizeBox() {
        window.onresize = () => {
          if (this.oWebControl != null) {
            this.oWebControl.JS_Resize(this.swfWidth, this.swfHeight)
            this.setWndCover()
          }
        }
        // 监听滚动条scroll事件，使插件窗口跟随浏览器滚动而移动
        $(window).scroll(() => {
          if (this.oWebControl != null) {
            this.oWebControl.JS_Resize(this.swfWidth, this.swfHeight)
            this.setWndCover()
          }
        })
      },
      // 停止全部预览功能
      stopAllPreview() {
        this.oWebControl.JS_RequestInterface({
          funcName: 'stopAllPreview',
        })
      },
      // 关闭视频窗口
      closeWindow() {
        console.log(this.oWebControl, '关闭视频窗口')
        if (this.oWebControl != null) {
          this.oWebControl.JS_HideWnd() // 先让窗口隐藏，规避可能的插件窗口滞后于浏览器消失问题
          this.oWebControl.JS_Disconnect().then(
            () => {
              // 断开与插件服务连接成功
              this.oWebControl = null
            },
            () => {
              // 断开与插件服务连接失败
            }
          )
        }
      },
    },
    beforeDestroy() {
      this.closeWindow() // 关闭插件
    },
  }
</script>
<style lang="scss" scoped>
  .nav {
    height: 40px;
    .tags {
      color: #fff;
      cursor: pointer;
      li {
        padding: 5px 20px;
        line-height: 2;
        transition: all 0.5s;
      }
      li.active {
        background: url('../../../assets/monitor/active.png') no-repeat;
        background-size: 100% 100%;
      }
    }

    .page-con {
      color: #24d996;
      cursor: pointer;
      align-items: center;
      div {
        padding: 5px 20px;
        background: url('../../../assets/monitor/active.png') no-repeat;
        background-size: 100% 100%;
      }
      span {
        margin: 0 20px;
        i {
          color: #fff;
          font-style: normal;
        }
      }
    }
  }

  #playWnd {
    margin-top: 2vh;
    height: 72vh;
    color: #fff;
  }
</style>
